import styled from 'styled-components';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles<Theme>((theme) => ({
  inputAutoCompleteCheckbox: {
    position: 'relative',
    zIndex: 10,
    
    '& .MuiAutocomplete-inputRoot': {
      background: theme.palette.background.paper,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7'
    },
    '& .MuiFormHelperText-root': {
      background: 'transparent',
      '.MuiChip-label': {
        background: 'red'
      }
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
      color: theme.palette.error.main,
    },
  },
  listboxOption: {
    '&.MuiAutocomplete-option': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      minHeight: 48,
      padding: '6px 8px',
      cursor: 'pointer',
      '&:hover, &.Mui-focused': {
        backgroundColor: theme.palette.grey[100]
      },
      '&[aria-selected="true"]': {
        backgroundColor: theme.palette.primary.light
      }
    }
  },
  chip: {
    display: 'flex',
    justifyContent: 'space-between',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '350px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '200px'
    }
  }
}));
export const Container = styled.div`
  width: 100%;
`;
export const OptionTextLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;